(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seat-comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const escapeHtml = (value) => String(value ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');

    const init = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const max = Number(root.dataset.max || 3);
      const cards = Array.from(root.querySelectorAll('[data-product-card]'));
      const filters = Array.from(root.querySelectorAll('[data-filter]'));
      const slots = root.querySelector('[data-slots]');
      const status = root.querySelector('[data-status]');
      const empty = root.querySelector('[data-empty]');
      const result = root.querySelector('[data-result]');
      let selected = [];

      const productFromCard = (card) => ({
        id: card.dataset.productId,
        title: card.dataset.title,
        url: card.dataset.url,
        image: card.dataset.image,
        price: card.dataset.price,
        availability: card.dataset.availability,
        specs: {
          height: card.dataset.height,
          r129: card.dataset.r129,
          rotation: card.dataset.rotation,
          rearFacing: card.dataset.rearFacing,
          fitting: card.dataset.fitting,
          headrest: card.dataset.headrest,
          recline: card.dataset.recline,
          goodFor: card.dataset.goodFor
        }
      });

      const renderSlots = () => {
        slots.innerHTML = Array.from({ length: max }, (_, index) => {
          const product = selected[index];
          if (!product) {
            return '<div class="seat-compare__slot is-empty">Choose a seat</div>';
          }

          return `<button type="button" class="seat-compare__slot" data-remove-id="${escapeHtml(product.id)}" aria-label="Remove ${escapeHtml(product.title)} from comparison">
            <img src="${escapeHtml(product.image)}" alt="" width="44" height="50" loading="lazy">
            <span class="seat-compare__slot-name">${escapeHtml(product.title)}</span>
            <span class="seat-compare__slot-remove" aria-hidden="true">×</span>
          </button>`;
        }).join('');
      };

      const renderTable = () => {
        if (selected.length < 2) {
          result.hidden = true;
          result.innerHTML = '';
          empty.hidden = false;
          return;
        }

        const rows = [
          ['Height range', 'height'],
          ['R129 i-Size', 'r129'],
          ['360° rotation', 'rotation'],
          ['Rear-facing', 'rearFacing'],
          ['Fitting options', 'fitting'],
          ['Headrest positions', 'headrest'],
          ['Recline positions', 'recline'],
          ['Good fit when you want…', 'goodFor']
        ];

        const headings = selected.map((product) => `<th scope="col" class="seat-compare__table-product">
          <img src="${escapeHtml(product.image)}" alt="" width="72" height="82" loading="lazy">
          <strong>${escapeHtml(product.title)}</strong>
          <span>${escapeHtml(product.price)}</span>
          <span>${escapeHtml(product.availability)}</span>
          <a href="${escapeHtml(product.url)}">View seat</a>
        </th>`).join('');

        const body = rows.map(([label, key]) => `<tr>
          <th scope="row" class="seat-compare__feature">${escapeHtml(label)}</th>
          ${selected.map((product) => `<td>${escapeHtml(product.specs[key])}</td>`).join('')}
        </tr>`).join('');

        result.innerHTML = `<h2>Comparison</h2>
          <p>On mobile, swipe left and right to see every selected seat.</p>
          <div class="seat-compare__table-wrap" role="region" aria-label="Selected car-seat comparison" tabindex="0">
            <table class="seat-compare__table">
              <thead>
                <tr>
                  <th scope="col" class="seat-compare__feature">Feature</th>
                  ${headings}
                </tr>
              </thead>
              <tbody>${body}</tbody>
            </table>
          </div>`;
        empty.hidden = true;
        result.hidden = false;
      };

      const render = () => {
        cards.forEach((card) => {
          const isSelected = selected.some((product) => product.id === card.dataset.productId);
          card.classList.toggle('is-selected', isSelected);
          card.setAttribute('aria-pressed', String(isSelected));
          const label = card.querySelector('.seat-compare__select-label');
          if (label) label.textContent = isSelected ? 'Remove from comparison' : 'Add to comparison';
        });
        renderSlots();
        renderTable();
      };

      const update = () => {
        if (document.startViewTransition) {
          document.startViewTransition(render);
        } else {
          render();
        }
      };

      root.addEventListener('click', (event) => {
        const filter = event.target.closest('[data-filter]');
        if (filter) {
          const category = filter.dataset.filter;
          filters.forEach((button) => {
            const active = button === filter;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', String(active));
          });
          cards.forEach((card) => {
            const categories = card.dataset.categories.split(' ');
            card.hidden = category !== 'all' && !categories.includes(category);
          });
          status.textContent = '';
          return;
        }

        const remove = event.target.closest('[data-remove-id]');
        if (remove) {
          selected = selected.filter((product) => product.id !== remove.dataset.removeId);
          status.textContent = '';
          update();
          return;
        }

        const card = event.target.closest('[data-product-card]');
        if (!card) return;

        const existing = selected.findIndex((product) => product.id === card.dataset.productId);
        if (existing >= 0) {
          selected.splice(existing, 1);
          status.textContent = '';
          update();
          return;
        }

        if (selected.length >= max) {
          status.textContent = 'You can compare up to three seats. Remove one before choosing another.';
          return;
        }

        selected.push(productFromCard(card));
        status.textContent = selected.length === 1
          ? 'One seat selected. Choose at least one more.'
          : `${selected.length} seats selected.`;
        update();
      });

      render();
    };

    document.querySelectorAll('[data-seat-comparison]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      init(event.target.querySelector('[data-seat-comparison]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
